import angular from 'angular';
import _ from 'lodash';

export const AnnualHiringFunnel = (StatsService, $q, $filter) => {
    const getAnunualHiringFunnel = function (fromDate, recruiterId, callback) {
        const requestBody = {
            from: fromDate,
        };
        if (recruiterId) {
            requestBody.recruiterIds = [recruiterId];
        } else {
            requestBody.allRecruiters = true;
        }
        StatsService.getHiringFunnelByTimeFrame(requestBody)
            .then((response) => {
                let newDataSource = [
                    {
                        state: $filter('translate')('SENT_HIRING_FUNNEL'),
                        candidates: 0,
                        rejected: 0,
                        undecided: 0,
                    },
                    {
                        state: $filter('translate')('CLAIMED_HIRING_FUNNEL'),
                        candidates: 0,
                        rejected: 0,
                        undecided: 0,
                    },
                    {
                        state: $filter('translate')('INTERVIEW_HIRING_FUNNEL'),
                        candidates: 0,
                        rejected: 0,
                        undecided: 0,
                    },
                    {
                        state: $filter('translate')('NEGOTIATION_HIRING_FUNNEL'),
                        candidates: 0,
                        rejected: 0,
                        undecided: 0,
                    },
                    {
                        state: $filter('translate')('HIRED_HIRING_FUNNEL'),
                        candidates: 0,
                        rejected: 0,
                        undecided: 0,
                    },
                ];
                if (response && response.result.length > 0) {
                    const dataSource = _.map(_.groupBy(response.result, 'category'), (category) => {
                        const candidates = _.find(category, { status: 'ok' });
                        const rejected = _.find(category, { status: 'rejected' });
                        const undecided = _.find(category, { status: 'undecided' });
                        return {
                            state: category[0].category,
                            candidates: candidates ? candidates.count : 0,
                            rejected: rejected ? rejected.count : 0,
                            undecided: undecided ? undecided.count : 0,
                        };
                    });

                    const sent = _.findIndex(dataSource, { state: 'sent' });
                    if (sent > -1) {
                        newDataSource[0].candidates = dataSource[sent].candidates;
                        newDataSource[0].rejected = dataSource[sent].rejected;
                        newDataSource[0].undecided = dataSource[sent].undecided;
                    }

                    const claimed = _.findIndex(dataSource, { state: 'claimed' });
                    if (claimed > -1) {
                        newDataSource[1].candidates = dataSource[claimed].candidates;
                        newDataSource[1].rejected = dataSource[claimed].rejected;
                        newDataSource[1].undecided = dataSource[claimed].undecided;
                    }

                    const interview = _.findIndex(dataSource, { state: 'interview-assessment' });
                    if (interview > -1) {
                        newDataSource[2].candidates = dataSource[interview].candidates;
                        newDataSource[2].rejected = dataSource[interview].rejected;
                        newDataSource[2].undecided = dataSource[interview].undecided;
                    }

                    const negotiation = _.findIndex(dataSource, { state: 'negotiation' });
                    if (negotiation > -1) {
                        newDataSource[3].candidates = dataSource[negotiation].candidates;
                        newDataSource[3].rejected = dataSource[negotiation].rejected;
                        newDataSource[3].undecided = dataSource[negotiation].undecided;
                    }

                    const hired = _.findIndex(dataSource, { state: 'hired' });
                    if (hired > -1) {
                        newDataSource[4].candidates = dataSource[hired].candidates;
                        newDataSource[4].rejected = dataSource[hired].rejected;
                        newDataSource[4].undecided = dataSource[hired].undecided;
                    }
                }


                const options = {
                    dataSource: newDataSource,
                    barWidth: 0.72,
                    size: {
                        height: 235,
                    },

                    commonSeriesSettings: {
                        argumentField: 'state',
                        type: 'stackedBar',
                    },
                    commonAxisSettings: {
                        label: {
                            visible: true, // Show text labels
                            font: {
                                color: '#000000',
                                family: 'Source Sans Pro',
                                weight: 400,
                                size: 12,
                            },
                        },
                    },
                    equalBarWidth: true,
                    series: [
                        {
                            valueField: 'candidates',
                            name: 'Candidates',
                            color: '#F7BF55'
                        },
                        {
                            valueField: 'rejected',
                            name: 'Rejected',
                            color: '#B57D1D'
                        },
                        {
                            valueField: 'undecided',
                            name: 'Undecided',
                            color: '#FEDEA2'
                        },
                        {
                            valueField: 'percentRatio',
                            name: '&nbsp;',
                            color: 'dummyColor'
                        },
                    ],
                    legend: {
                        verticalAlignment: 'bottom',
                        horizontalAlignment: 'center',
                        itemTextPosition: 'right',
                        font: {
                            color: '#000000',
                            family: 'Source Sans Pro',
                            weight: 400,
                            size: 15,
                        },
                        margin: {
                            top: 33,
                        },
                    },
                    tooltip: {
                        enabled: true,
                        paddingLeftRight: 12,
                        paddingTopBottom: 10,
                        customizeTooltip(arg) {
                            return {
                                text: `${arg.percentText} - ${arg.valueText}`,
                            };
                        },
                    },
                };

                callback({
                    options,
                });
            });
    };

    return {
        getAnunualHiringFunnel,
    };
};

angular
    .module('TALENYA-FE')
    .factory('AnnualHiringFunnel', AnnualHiringFunnel);
